export enum PeriodPresetEnum {
    LAST_24_HOURS = 'LAST_24_HOURS',
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_3_MONTHS = 'LAST_3_MONTHS',
    PREVIOUS_WEEK = 'PREVIOUS_WEEK',
    PREVIOUS_MONTH = 'PREVIOUS_MONTH',
    CURRENT_MONTH = 'CURRENT_MONTH',
    CURRENT_YEAR = 'CURRENT_YEAR',
    PREVIOUS_YEAR = 'PREVIOUS_YEAR'
}

export interface PeriodPreset {
    label: string;
    name: PeriodPresetEnum;
    startAt: () => Date;
    period: () => number;
}
